import { ChevronLeftIcon } from "@heroicons/react/20/solid"
import { Button } from "components/Button/Button"
import { LanguageSwitch } from "components/LanguageSwitch/LanguageSwitch"
import { MijnPraktijkLogo } from "components/Logo/MijnPraktijkLogo"
import { APP_NAME } from "configs/AppConfig"
import { useTranslate } from "hooks/useTranslate"
import { useNavigate } from "react-router"

interface DefaultNavigationBarProps {
  removeBackButton?: boolean
}

export const DefaultNavigationBar = ({ removeBackButton = false }: DefaultNavigationBarProps) => {
  const t = useTranslate()
  const navigate = useNavigate()

  return (
    <div className="fixed top-0 flex h-16 w-full items-center justify-between border-b border-[#E8EAF0] bg-white p-2">
      {!removeBackButton && (
        <Button
          type="button"
          variant="text"
          impact="none"
          prefixIcon={<ChevronLeftIcon className="size-5" />}
          onClick={() => void navigate(-1)}
        >
          {t("button.back")}
        </Button>
      )}
      <div className="flex w-full items-center justify-center gap-2">
        <MijnPraktijkLogo />
        <span className="text-body1/medium font-[700] text-[#2E2E63]">{APP_NAME}</span>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        <LanguageSwitch addArrow />
      </div>
    </div>
  )
}
